import { createContext, useContext, useReducer, useEffect } from 'react';
import { usePitchContext } from '../context/pitchContext';
import reducer from '../reducer/filterRedcuer'
const FilterContext = createContext();

const initialState = {
    filter_products: [],
    all_products: [],
    filters: {
        text: ""
    }
}

const FilterContextProvider = ({ children }) => {

    const { pitch } = usePitchContext();
    const [state, dispatch] = useReducer(reducer, initialState);

    const updateFilterValue = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        value = value.toLowerCase();

        return dispatch({ type: "UPDATE_FILTERS_VALUE", payload: { name, value } });
    };

    useEffect(() => {
        dispatch({ type: "FILTER_PRODUCTS" });
    }, [pitch, state.filters]);

    useEffect(() => {
        dispatch({ type: 'LOAD_FILTER_PRODUCTS', payload: pitch })
    }, [pitch]);


    return (
        <FilterContext.Provider value={{ ...state, updateFilterValue}}>
            {children}
        </FilterContext.Provider>
    )
}

export const useFilterContext = () => {
    return useContext(FilterContext);
}

export { FilterContextProvider }